import { Form, Input, Modal, Radio, Result, Spin, Tooltip, Button, Select } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { testVeloyd } from '../../../../modules/settings/api';
import { ReactSVG } from 'react-svg';
import { ROLES } from '../../../../constants';

export const VeloydCarrier = ({ done, carrier, handleUpdate, users }) => {
  const [form] = Form.useForm();
  const [responseMessage, setResponseMessage] = useState('');
  const [isTesting, setIsTesting] = useState(false);
  const spinning = useMemo(() => isTesting, [isTesting]);

  const disableApiKey = useMemo(() => carrier?.credentials?.apiKey?.startsWith('...'), [carrier]);

  const handleCancel = () => {
    form.resetFields();
    done();
  };

  const isNew = carrier === undefined;

  const submit = (values) => {
    if (isNew) {
      // do something for new integration
      handleUpdate({
        name: values.name,
        carrierService: 'VELOYD',
        credentials: {
          apiKey: values.apiKey,
          createAs: values.createAs,
        },
        userIds: values.carrierUsers,
      });
    } else {
      const { ...carrierInfo } = carrier;
      const updatedCarrier = {
        ...carrierInfo,
        name: values.name,
        credentials: {
          apiKey: disableApiKey ? undefined : values.apiKey,
          createAs: values.createAs,
        },
        userIds: values.carrierUsers,
      };
      handleUpdate(updatedCarrier);
    }
    form.resetFields();
    done({ refetch: true });
  };

  const handleModalOk = () => {
    setResponseMessage('');
  };

  useEffect(() => {
    if (carrier) {
      form.setFieldsValue({
        carrierUsers: carrier.users.map((cu) => cu.id),
      });
    }
  }, [carrier]);

  const handleTest = () => {
    const fieldValues = form.getFieldsValue();
    setIsTesting(true);
    (async () => {
      const response = await testVeloyd({ veloydKey: fieldValues.apiKey });
      if (response.response?.message === 'success') {
        setResponseMessage('API key validation successful!');
      } else {
        setResponseMessage('There was an issue with the API key. Please verify and try again.');
      }
    })();
    setIsTesting(false);
  };

  //   const turnOff = async () => {
  //     done({ refetch: true });
  //     console.log('delete an existing integration');
  //   };

  return (
    <Spin spinning={spinning}>
      <div className="RoutePlanForm">
        <Form form={form} onFinish={submit} layout="vertical" requiredMark={false} colon={false}>
          <Form.Item
            label="Name"
            value={isNew ? '' : carrier?.name}
            initialValue={isNew ? '' : carrier?.name}
            name="name"
            rules={[{ required: true, message: 'Required' }]}
          >
            <Input placeholder="Give this carrier integration a name" size="large" />
          </Form.Item>

          <Form.Item
            label="API Key"
            value={isNew ? '' : carrier?.credentials?.apiKey}
            initialValue={isNew ? '' : carrier?.credentials?.apiKey}
            name="apiKey"
            rules={[{ required: !disableApiKey, message: 'Required' }]}
          >
            <Input placeholder="Your veloyd api key" size="large" disabled={disableApiKey} />
          </Form.Item>

          <Form.Item
            label="How do you want to create orders in Veloyd?"
            value={isNew ? '' : carrier?.config?.createAs}
            initialValue={isNew ? '' : carrier?.config?.createAs}
            name="createAs"
            rules={[{ required: true, message: 'Required' }]}
          >
            <Radio.Group
              options={[
                { label: 'Orders', value: 'ORDER' },
                { label: 'Parcels', value: 'PARCEL' },
              ]}
            />
          </Form.Item>

          <Form.Item label="Carrier Users" name="carrierUsers">
            <Select
              mode="multiple"
              size="large"
              allowClear
              options={users
                ?.filter((user) => user?.role === ROLES.CARRIER_USER)
                .map((user) => ({
                  label: user.name,
                  value: user.id,
                }))}
            />
          </Form.Item>

          <div className="FormFooter">
            <Button key="test" type="primary" onClick={handleTest} disabled={disableApiKey}>
              Test
            </Button>
            <Modal
              title="Test Result"
              visible={!!responseMessage}
              onOk={handleModalOk}
              onCancel={handleModalOk}
              width={400}
            >
              <Result status={responseMessage.includes('successful') ? 'success' : 'warning'} title={responseMessage} />
            </Modal>

            {/* {!isNew && (
              <Popconfirm
                title="Are you sure you want to turn off the Veloyd integration?"
                onConfirm={turnOff}
                okText="Yes"
                cancelText="No"
              >
                <Button key="delete" size="small" danger>
                  Turn off Veloyd
                </Button>
              </Popconfirm>
            )} */}

            <Button key="cancel" size="small" onClick={handleCancel}>
              Cancel
            </Button>
            <Tooltip
              title="By enabling the veloyd integration, you can add the integration to delivery areas, just like any other carrier."
              placement="right"
            >
              <Button key="confirm" type="primary" size="small" htmlType="submit">
                {isNew ? 'Add' : 'Update'} integration
                <ReactSVG className="icon" src="/icons/done.svg" />
              </Button>
            </Tooltip>
          </div>
        </Form>
      </div>
    </Spin>
  );
};
